import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
/**
 * Container for the action buttons to take care of the spacing.
 */
export function ActionButtonContainer(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mx: "1.5px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Box component="div" sx={t1}>{children}</Box>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}